$(document).ready(function () {
  // Toggle custom start/end date fields when the timeline dropdown changes to/from 'Custom'
  $(document).on('change', '.report-exporters-see-through-lifecycle-report-component .selected-timeline-js', function () {
    const dateFields = $(this).closest('.report-exporters-see-through-lifecycle-report-component').find('.custom-timeline-dropdowns-js');

    if ($(this).val() === 'Custom') {
      dateFields.removeClass('d-none');
    } else {
      dateFields.addClass('d-none');
    }
  });
});
